// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';

export const newConfigurationPageActions = {
  GET_FILE_URLS: 'GET_FILE_URLS',
  SAVE_NETWORK_CONFIG: 'SAVE_NETWORK_CONFIG',
  RUN_CONFIGURATION: 'RUN_CONFIGURATION',
  GET_CONFIGS_WITH_ID: 'GET_CONFIGS_WITH_ID'
};

export const getDefaultConfigsAction = (obj: Object) => ({
  type: newConfigurationPageActions.GET_FILE_URLS,
  payload: obj
});

export const saveNetworkConfigAction = (obj: Object) => ({
  type: newConfigurationPageActions.SAVE_NETWORK_CONFIG,
  payload: obj
});

export const saveOrRunConfigurationAction = (obj: Object) => ({
  type: newConfigurationPageActions.RUN_CONFIGURATION,
  payload: obj
});

export const getConfigsWithIdAction = (obj: Object) => ({
  type: newConfigurationPageActions.GET_CONFIGS_WITH_ID,
  payload: obj
});

export const getConfigsWithId = configId => dispatch => {
  dispatch(
    saveOrRunConfigurationAction({
      fetching: true,
      fetched: false,
      fileUrls: null,
      configurationPageDetails: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getNetworkConfig',
    pathVariables: [{ key: '{configId}', val: configId }],
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getConfigsWithIdAction({
            fetched: true,
            fetching: false,
            fileUrls: res.payload,
            configurationPageDetails: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getConfigsWithIdAction({
            fetched: true,
            fetching: false,
            fileUrls: null,
            configurationPageDetails: null
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getConfigsWithIdAction({
          fetched: true,
          fetching: false,
          fileUrls: null,
          configurationPageDetails: null
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
      //  eslint-disable-next-line no-console
      console.log('Failed ', res);
    },
    catchCb: res => {
      dispatch(
        getConfigsWithIdAction({
          fetched: true,
          fetching: false,
          fileUrls: null,
          configurationPageDetails: null
        })
      );
      toastr.error(
        'Exception',
        'Exception in fetching default configs details',
        {
          timeout: 3000
        }
      );
      //  eslint-disable-next-line no-console
      console.log('Caught ', res);
    }
  };

  return makeApiCall(requestObj);
};

export const saveOrRunConfiguration = (
  configurationPageDetails,
  action,
  dagAction
) => dispatch => {
  let readyToRun = false;

  dispatch(
    saveOrRunConfigurationAction({
      fetching: true,
      fetched: false,
      networkmonitorStateForRun: null,
      readyToRun: false
      // configurationPageDetails: null,
      // fileUrls: null
    })
  );
  if (configurationPageDetails.configId === null || dagAction === 'RE_RUN') {
    configurationPageDetails.configId = '';
  }

  const formData = new FormData();

  formData.append('configId', configurationPageDetails.configId);
  formData.append('description', configurationPageDetails.description);
  if (configurationPageDetails.salesPlanS3URL) {
    formData.append('salesPlanS3URL', configurationPageDetails.salesPlanS3URL);
  } else {
    formData.append('salesPlanS3URL', '');
  }
  if (configurationPageDetails.oneWayTripInfoS3URL) {
    formData.append(
      'oneWayTripInfoS3URL',
      configurationPageDetails.oneWayTripInfoS3URL
    );
  } else {
    formData.append('oneWayTripInfoS3URL', '');
  }
  if (configurationPageDetails.networkConfigS3URL) {
    formData.append(
      'networkConfigS3URL',
      configurationPageDetails.networkConfigS3URL
    );
  } else {
    formData.append('networkConfigS3URL', '');
  }
  if (
    configurationPageDetails.salesPlanFile &&
    configurationPageDetails.salesPlanFile.length > 0
  ) {
    formData.append('salesPlanFile', configurationPageDetails.salesPlanFile[0]);
  } else {
    formData.append('salesPlanFile', '');
  }
  if (
    configurationPageDetails.oneWayTripInfoFile &&
    configurationPageDetails.oneWayTripInfoFile.length > 0
  ) {
    formData.append(
      'oneWayTripInfoFile',
      configurationPageDetails.oneWayTripInfoFile[0]
    );
  } else {
    formData.append('oneWayTripInfoFile', '');
  }

  if (
    configurationPageDetails.networkConfigFile &&
    configurationPageDetails.networkConfigFile.length > 0
  ) {
    formData.append(
      'networkConfigFile',
      configurationPageDetails.networkConfigFile[0]
    );
  } else {
    formData.append('networkConfigFile', '');
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'networkRunConfiguration',
    method: 'POST',
    postFormData: true,
    data: formData,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        if (action === 'RUN') {
          readyToRun = true;
        }
        dispatch(
          getDefaultConfigsAction({
            fetched: true,
            fetching: false,
            networkmonitorStateForRun: res.payload,
            readyToRun
          })
        );
        if (action === 'SAVE') {
          toastr.success('Sucess', 'Successfully saved configuration');
        } else {
          toastr.success('Sucess', 'Run configuration executed');
        }
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDefaultConfigsAction({
            fetched: true,
            fetching: false,
            readyToRun
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getDefaultConfigsAction({
          fetched: true,
          fetching: false,
          readyToRun
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
      //  eslint-disable-next-line no-console
      console.log('Failed ', res, this.state);
    },
    catchCb: res => {
      dispatch(
        getDefaultConfigsAction({
          fetched: true,
          fetching: false,
          readyToRun
        })
      );
      toastr.error(
        'Exception',
        'Exception in fetching default configs details',
        {
          timeout: 3000
        }
      );
      //  eslint-disable-next-line no-console
      console.log('Caught ', res);
    }
  };

  return makeApiCall(requestObj);
};

export const getDefaultConfigs = obj => dispatch => {
  // eslint-disable-next-line
  console.log(obj);
  dispatch(
    getDefaultConfigsAction({
      fetching: true,
      fetched: false,
      fileUrls: null,
      configurationPageDetails: null
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getNetworkDefaultConfigs',
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDefaultConfigsAction({
            fetched: true,
            fetching: false,
            fileUrls: res.payload,
            configurationPageDetails: res.payload
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDefaultConfigsAction({
            fetched: true,
            fetching: false,
            fileUrls: null,
            configurationPageDetails: null
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getDefaultConfigsAction({
          fetched: true,
          fetching: false,
          fileUrls: null,
          configurationPageDetails: null
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
      //  eslint-disable-next-line no-console
      console.log('Failed ', res);
    },
    catchCb: res => {
      dispatch(
        getDefaultConfigsAction({
          fetched: true,
          fetching: false,
          fileUrls: null,
          configurationPageDetails: null
        })
      );
      toastr.error(
        'Exception',
        'Exception in fetching default configs details',
        {
          timeout: 3000
        }
      );
      //  eslint-disable-next-line no-console
      console.log('Caught ', res);
    }
  };

  return makeApiCall(requestObj);
};
